import {inject, PLATFORM_ID} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';
import {isPlatformBrowser} from '@angular/common';
import {tap} from 'rxjs';

/**
 * Redirige vers /discover si l'utilisateur n'est pas admin ou vers /login si l'utilisateur n'est pas connecté
 * @param route
 * @param state
 * @constructor
 */
export const AdminGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService: AuthenticationService = inject(AuthenticationService);
  const router: Router = inject(Router);
  const platformId: any = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);
  if (isBrowser) {

    return authService.checkIfAdmin().pipe(
      tap(allowed => {
        if (!allowed) {
          router.navigate(['/login']);
        }
      })
    );
  }
};
